export interface ChargingReport {
  id: number;
  externalChargingStationId: string;
  chargingStationName: string;
  dateIssued: string;
  periodStart: string;
  periodEnd: string;
  type: ChargingReportType;
  totalChargingQuantityKwh: number;
  totalChargingAmountEuros: number;
  payableAmountEuros?: number;
  payablePriceEurosKwh?: number;
  dateCreated: string
}

export enum ChargingReportType {
  DEFAULT = "DEFAULT",
  MARGIN = "MARGIN",
  TURNOVER = "TURNOVER"
}

export const CHARGING_REPORT_TYPE_MAP: {[key in ChargingReportType]: string} = {
  DEFAULT: 'Üldine',
  TURNOVER: 'Protsent',
  MARGIN: 'Marginaal'
};

export const CHARGING_FEE_CALCULATION_TYPE_OPTIONS = [   
    {
        label: CHARGING_REPORT_TYPE_MAP[ChargingReportType.DEFAULT],
        value: ChargingReportType.DEFAULT,
    },
    {
        label: CHARGING_REPORT_TYPE_MAP[ChargingReportType.TURNOVER],
        value: ChargingReportType.TURNOVER,
    }, 
    {
        label: CHARGING_REPORT_TYPE_MAP[ChargingReportType.MARGIN],
        value: ChargingReportType.MARGIN,
    }
];

export enum ChargingReportSortFields {
  ID = "ID",
  DATE_ISSUED = "DATE_ISSUED",
  TYPE = "TYPE",
  EXTERNAL_CHARGING_STATION_ID = "EXTERNAL_CHARGING_STATION_ID"
}

export interface ChargingReportFilters {
  search?: string;
}